import type { FC } from 'react';
import { useInView } from 'react-intersection-observer';

import { useBooleanState } from '@mopla/utils';

import { Root, StyledImg, StyledImgPlaceholder } from './styled';

interface IBlurLazyImageProps {
	src: string;
	src2x: string;
	placeholderSrc: string;
	alt: string;
	width?: number | string;
	height?: number | string;
	className?: string;
}

export const BlurLazyImage: FC<IBlurLazyImageProps> = ({
	src,
	src2x,
	placeholderSrc,
	alt,
	width = '100%',
	height = 'auto',
	className,
}) => {
	const [loaded, setLoaded] = useBooleanState();
	const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.4 });

	return (
		<Root ref={ref} style={{ width, height }} className={className}>
			<StyledImgPlaceholder
				src={placeholderSrc}
				alt={`${alt} placeholder`}
				aria-hidden
				style={{
					opacity: loaded ? 0 : 1,
				}}
			/>

			{inView && (
				<StyledImg
					src={src}
					srcSet={`${src} 1x, ${src2x} 2x`}
					alt={alt}
					onLoad={setLoaded}
					style={{
						opacity: loaded ? 1 : 0,
					}}
				/>
			)}
		</Root>
	);
};
